import React from 'react';
import TableElementInterface from 'components/organisms/players-to-exchange/table-elements/table-element-interface';

const TableHeadComponent = (props: {heading: TableElementInterface}) => {
    return <th className={props.heading.className}>{props.heading.value}</th>;
};

export default TableHeadComponent;
